// material-ui
import { Box } from '@mui/material';

// third-party
import { createSlice } from '@reduxjs/toolkit';

// assets
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

// initial state
const initialState = {
    hidden: false,
    title: <Box />,
    separator: <ChevronRightIcon fontSize="small" />,
    showHome: true,
    items: []
};

// ==============================|| SLICE - BREADCRUMBS ||============================== //

const slice = createSlice({
    name: 'breadCrumbs',
    initialState,
    reducers: {
        setHidden(state, action) {
            state.hidden = Boolean(action?.payload);
        },
        setTitle(state, action) {
            state.title = action?.payload;
        },
        setSeparator(state, action) {
            state.separator = action?.payload;
        },
        setShowHome(state, action) {
            state.showHome = Boolean(action?.payload);
        },
        setItems(state, action) {
            state.items = action?.payload;
        },
        insertItem(state, action) {
            state.items.push(action?.payload);
        },
        updateItem(state, action) {
            action?.payload.forEach((newItem) => {
                const itemIndex = state.items.findIndex((oldItem) => oldItem.id === newItem.id);

                if (itemIndex !== -1) {
                    state.items.splice(itemIndex, 1, newItem);
                }
            });
        },
        deleteItem(state, action) {
            action?.payload.forEach((delId) => {
                const itemIndex = state.items.findIndex((item) => item.id === delId);

                if (itemIndex !== -1) {
                    state.items.splice(itemIndex, 1);
                }
            });
        }
    }
});

export default slice.reducer;

export const breadCrumbsActions = slice.actions;
